import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAround: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAround"><Path d="M21.5 6.5V18C21.5 18.9523 19.4769 19.7802 16.5 20.2023V15.7977V8.20229C19.4769 7.78016 21.5 6.95226 21.5 6C21.5 4.61929 17.2467 3.5 12 3.5C6.75329 3.5 2.5 4.61929 2.5 6C2.5 6.95226 4.52315 7.78016 7.5 8.20229V15.7977V20.2023C4.52315 19.7802 2.5 18.9523 2.5 18V6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.75488 15.7629C9.03249 15.5947 10.4743 15.5 12.0001 15.5C13.5259 15.5 14.9677 15.5947 16.2453 15.7629" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAround;
